module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center",
    attrs: {
      "id": "epigraph"
    }
  }, [_c('span', [_vm._v("God, how the dead men")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Grin by the wall,")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Watching the fun")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Of the Victory Ball.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("—Alfred Noyes,")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_c('i', [_vm._v("A Victory Dance")])])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('span', [_vm._v("Evil … has infinite forms.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("—Blaise Pascal,")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_c('i', [_vm._v("Pensees")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b648bfa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/5-epigraph.vue
// module id = 78
// module chunks = 0